interface WorkflowSVGProps {
  color: string;
  style: React.CSSProperties;
}

const WorkflowSVG = ({ color, style }: WorkflowSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
  >
    <path
      d="M36.4584 39.5832H45.8334M45.8334 39.5832L40.6251 34.3748M45.8334 39.5832L40.6251 44.7915M25.0001 4.1665L19.7917 9.37484L25.0001 14.5832"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.8751 9.375C26.0191 9.375 29.9934 11.0212 32.9236 13.9515C35.8539 16.8817 37.5001 20.856 37.5001 25C37.5001 29.144 35.8539 33.1183 32.9236 36.0485C29.9934 38.9788 26.0191 40.625 21.8751 40.625H4.16675"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.075 11.458C11.6955 12.8282 9.71921 14.8014 8.34542 17.1788C6.97163 19.5563 6.24887 22.2539 6.25 24.9997C6.25 28.5163 7.4125 31.7622 9.375 34.3747"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WorkflowSVG;
